import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/services/axios_custom';
import API_ENDPOINTS from '@/util/api';

export const fetchTableNames = createAsyncThunk(
  'tableNames/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(API_ENDPOINTS.config.tableName);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
